module.exports = __webpack_public_path__ + "img/brief-image.1360d749.png";